import React, { FunctionComponent } from "react";
import {
  RoundHistoryComponentProps,
  GameCodes,
  GameShortCodes,
  GameShortCodeArray,
  GameInfoProps,
} from "./type";
import {
  SugarBlastRoundHistoryView as SugarBlast2RoundHistoryView,
  SugarBlastRuleView as SugarBlast2RuleView,
  SugarBlastSettingView as SugarBlast2SettingView,
} from "./views/sugar-blast2";
import {
  SugarBlastRoundHistoryView,
  SugarBlastRuleView,
  SugarBlastSettingView,
} from "./views/sugar-blast";
import {
  CoinDozerRoundHistoryView,
  CoinDozerRuleView,
  CoinDozerSettingView,
} from "./views/coin-dozer";
import {
  VikingBlastRoundHistoryView,
  VikingBlastRuleView,
  VikingBlastSettingView,
} from "./views/viking-blast";
import {
  RoosterBlitzRoundHistoryView,
  RoosterBlitzRuleView,
  RoosterBlitzSettingView,
} from "./views/rooster-blitz";

import {
  OlympusGloryRoundHistoryView,
  OlympusGloryRuleView,
  OlympusGlorySettingView,
} from "./views/olympus-glory";

import {
  CleopatrasTreasureRoundHistoryView,
  CleopatrasTreasureRuleView,
  CleopatrasTreasureSettingView,
} from "./views/cleopatras-treasure";

import {
  GoldRushBonanzaRoundHistoryView,
  GoldRushBonanzaRuleView,
  GoldRushBonanzaSettingView,
} from "./views/gold-rush-bonanza";

import {
  PiratesTreasureRoundHistoryView,
  PiratesTreasureRuleView,
  PiratesTreasureSettingView,
} from "./views/pirates-treasure";

import {
  HippoSplashRoundHistoryView,
  HippoSplashRuleView,
  HippoSplashSettingView,
} from "./views/hippo-splash";
import {
  HunkCaiShenRoundHistoryView,
  HunkCaiShenRuleView,
  HunkCaiShenSettingView,
} from "./views/hunk-cai-shen";

import {
  DearSenpaiRoundHistoryView,
  DearSenpaiRuleView,
  DearSenpaiSettingView,
} from "./views/dear-senpai";

export type GameContent = {
  gameCode: GameCodes;
  // title: GameTitles;
  historyComponent: FunctionComponent<RoundHistoryComponentProps>;
  ruleComponent: FunctionComponent<GameInfoProps>;
  settingComponent: FunctionComponent<GameInfoProps>;
};

export const DefaultGameContent: GameContent = {
  gameCode: GameCodes.Unknown,
  // title: GameTitles.Unknown,
  historyComponent: () => <></>,
  ruleComponent: () => <></>,
  settingComponent: () => <></>,
};

const regex = new RegExp(`^slot-(${GameShortCodeArray.join("|")})[-1]{1}`, "i");

const SugarBlastGameContent = {
  gameCode: GameCodes.SugarBlast,
  // title: GameTitles.SugarBlast,
  historyComponent: SugarBlastRoundHistoryView,
  ruleComponent: SugarBlastRuleView,
  settingComponent: SugarBlastSettingView,
};

const SugarBlast2GameContent = {
  gameCode: GameCodes.SugarBlast2,
  // title: GameTitles.SugarBlast2,
  historyComponent: SugarBlast2RoundHistoryView,
  ruleComponent: SugarBlast2RuleView,
  settingComponent: SugarBlast2SettingView,
};

const CoinDozerGameContent = {
  gameCode: GameCodes.CoinDozer,
  // title: GameTitles.CoinDozer,
  historyComponent: CoinDozerRoundHistoryView,
  ruleComponent: CoinDozerRuleView,
  settingComponent: CoinDozerSettingView,
};

const VikingBlastGameContent = {
  gameCode: GameCodes.VikingBlast,
  // title: GameTitles.VikingBlast,
  historyComponent: VikingBlastRoundHistoryView,
  ruleComponent: VikingBlastRuleView,
  settingComponent: VikingBlastSettingView,
};

const RoosterBlitzGameContent = {
  gameCode: GameCodes.RoosterBlitz,
  // title: GameTitles.RoosterBlitz,
  historyComponent: RoosterBlitzRoundHistoryView,
  ruleComponent: RoosterBlitzRuleView,
  settingComponent: RoosterBlitzSettingView,
};

const OlympusGloryGameContent = {
  gameCode: GameCodes.OlympusGlory,
  // title: GameTitles.OlympusGlory,
  historyComponent: OlympusGloryRoundHistoryView,
  ruleComponent: OlympusGloryRuleView,
  settingComponent: OlympusGlorySettingView,
};

const CleopatrasTreasureGameContent = {
  gameCode: GameCodes.CleopatrasTreasure,
  // title: GameTitles.CleopatrasTreasure,
  historyComponent: CleopatrasTreasureRoundHistoryView,
  ruleComponent: CleopatrasTreasureRuleView,
  settingComponent: CleopatrasTreasureSettingView,
};

const GoldRushBonanzaGameContent = {
  gameCode: GameCodes.GoldRushBonanza,
  // title: GameTitles.GoldRushBonanza,
  historyComponent: GoldRushBonanzaRoundHistoryView,
  ruleComponent: GoldRushBonanzaRuleView,
  settingComponent: GoldRushBonanzaSettingView,
};

const PiratesTreasureGameContent = {
  gameCode: GameCodes.PiratesTreasure,
  // title: GameTitles.PiratesTreasure,
  historyComponent: PiratesTreasureRoundHistoryView,
  ruleComponent: PiratesTreasureRuleView,
  settingComponent: PiratesTreasureSettingView,
};

const HippoSplashGameContent = {
  gameCode: GameCodes.HippoSplash,
  // title: GameTitles.HippoSplash,
  historyComponent: HippoSplashRoundHistoryView,
  ruleComponent: HippoSplashRuleView,
  settingComponent: HippoSplashSettingView,
};

const HunkCaiShenGameContent = {
  gameCode: GameCodes.HunkCaiShen,
  // title: GameTitles.HunkCaiShen,
  historyComponent: HunkCaiShenRoundHistoryView,
  ruleComponent: HunkCaiShenRuleView,
  settingComponent: HunkCaiShenSettingView,
};

const DearSenpaiGameContent = {
  gameCode: GameCodes.DearSenpai,
  // title: GameTitles.DearSenpai,
  historyComponent: DearSenpaiRoundHistoryView,
  ruleComponent: DearSenpaiRuleView,
  settingComponent: DearSenpaiSettingView,
};

const GameProvider = {
  determineGameCode(id: string): GameCodes {
    const content = regex.exec(id);
    if (!content) return GameCodes.Unknown;

    const shortCode = content[1].toLowerCase();
    switch (shortCode) {
      case GameShortCodes.SugarBlast:
        return GameCodes.SugarBlast;
      case GameShortCodes.SugarBlast2:
        return GameCodes.SugarBlast2;
      case GameShortCodes.CoinDozer:
        return GameCodes.CoinDozer;
      case GameShortCodes.VikingBlast:
        return GameCodes.VikingBlast;
      case GameShortCodes.RoosterBlitz:
        return GameCodes.RoosterBlitz;
      case GameShortCodes.OlympusGlory:
        return GameCodes.OlympusGlory;
      case GameShortCodes.CleopatrasTreasure:
        return GameCodes.CleopatrasTreasure;
      case GameShortCodes.GoldRushBonanza:
        return GameCodes.GoldRushBonanza;
      case GameShortCodes.PiratesTreasure:
        return GameCodes.PiratesTreasure;
      case GameShortCodes.HippoSplash:
        return GameCodes.HippoSplash;
      case GameShortCodes.HunkCaiShen:
        return GameCodes.HunkCaiShen;
      case GameShortCodes.DearSenpai:
        return GameCodes.DearSenpai;
      default:
        return GameCodes.Unknown;
    }
  },
  convertGameCode(raw: string): GameCodes {
    switch (raw) {
      case GameCodes.SugarBlast:
        return GameCodes.SugarBlast;
      case GameCodes.SugarBlast2:
        return GameCodes.SugarBlast2;
      case GameCodes.CoinDozer:
      case GameCodes.CoinPusher:
        return GameCodes.CoinDozer;
      case GameCodes.RoosterBlitz:
        return GameCodes.RoosterBlitz;
      case GameCodes.VikingBlast:
      case GameCodes.GemsOfVahalla:
        return GameCodes.VikingBlast;
      case GameCodes.OlympusGlory:
        return GameCodes.OlympusGlory;
      case GameCodes.CleopatrasTreasure:
        return GameCodes.CleopatrasTreasure;
      case GameCodes.GoldRushBonanza:
        return GameCodes.GoldRushBonanza;
      case GameCodes.PiratesTreasure:
        return GameCodes.PiratesTreasure;
      case GameCodes.HippoSplash:
        return GameCodes.HippoSplash;
      case GameCodes.HunkCaiShen:
        return GameCodes.HunkCaiShen;
      case GameCodes.DearSenpai:
        return GameCodes.DearSenpai;
      default:
        return GameCodes.Unknown;
    }
  },
  getGameRoundHistoryView(
    gameCode: GameCodes
  ): FunctionComponent<RoundHistoryComponentProps> {
    return getGameContent(gameCode).historyComponent;
  },
  getGameRuleView(gameCode: GameCodes): FunctionComponent<GameInfoProps> {
    return getGameContent(gameCode).ruleComponent;
  },
  getGameSettingView(gameCode: GameCodes): FunctionComponent<GameInfoProps> {
    return getGameContent(gameCode).settingComponent;
  },
};

function getGameContent(gameCode: GameCodes): GameContent {
  switch (gameCode) {
    case GameCodes.SugarBlast:
      return SugarBlastGameContent;
    case GameCodes.SugarBlast2:
      return SugarBlast2GameContent;
    case GameCodes.CoinDozer:
    case GameCodes.CoinPusher:
      return CoinDozerGameContent;
    case GameCodes.VikingBlast:
    case GameCodes.GemsOfVahalla:
      return VikingBlastGameContent;
    case GameCodes.RoosterBlitz:
      return RoosterBlitzGameContent;
    case GameCodes.OlympusGlory:
      return OlympusGloryGameContent;
    case GameCodes.CleopatrasTreasure:
      return CleopatrasTreasureGameContent;
    case GameCodes.GoldRushBonanza:
      return GoldRushBonanzaGameContent;
    case GameCodes.PiratesTreasure:
      return PiratesTreasureGameContent;
    case GameCodes.HippoSplash:
      return HippoSplashGameContent;
    case GameCodes.HunkCaiShen:
      return HunkCaiShenGameContent;
    case GameCodes.DearSenpai:
      return DearSenpaiGameContent;
    default:
      return DefaultGameContent;
  }
}

export default GameProvider;
